import React from 'react';
import { Alert } from 'src/modules/shared/components/atoms/alert';

/** Props for the pending-logo design-selection notice. */
interface WebsitePendingLogoNoticeProps {
  /** Managed logo waiting for the current draft to be saved. */
  pendingLogoFileId: string | null;
  /** Localized guidance for resolving the pending logo. */
  text: string;
}

/**
 * Explains why design changes are locked while an uploaded logo waits to be
 * saved.
 *
 * @param props - Pending logo and guidance text.
 * @returns The notice, or nothing when no logo is pending.
 */
export const WebsitePendingLogoNotice: React.FC<
  WebsitePendingLogoNoticeProps
> = ({ pendingLogoFileId, text }) =>
  pendingLogoFileId ? <Alert variant="warning" message={text} /> : null;
